module.exports = __webpack_public_path__ + "static/logoIconWhite-a681945a406968565bb2761b42efc0ea.png";